module.exports = {"name":"ArchivePlugin","version":"2.5.1","description":"","repository":{"type":"git","url":"graylog-plugin-archive"},"scripts":{"build":"webpack --bail"},"keywords":["graylog"],"author":"Bernd Ahlers <bernd@graylog.com>","license":"UNLICENSED","private":true,"dependencies":{"moment":"2.14.1","moment-duration-format":"1.3.0","twix":"^1.1.4"},"devDependencies":{"graylog-web-plugin":"file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 156
// module chunks = 0